export const defaultPageSize: number = 10;
export const naProvider: string = 'NA';
export const euProvider: string = 'EU';
export const enLocale: string = 'en';
export const frLocale: string = 'fr';